import { render } from "./WebsiteOrders.vue?vue&type=template&id=97614d0c&scoped=true"
import script from "./WebsiteOrders.vue?vue&type=script&lang=js"
export * from "./WebsiteOrders.vue?vue&type=script&lang=js"

import "./WebsiteOrders.vue?vue&type=style&index=0&id=97614d0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-97614d0c"

export default script